import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';

export function serializeActionInput(answer: AnswerValue): string {
  if (answer === undefined) return 'skip';
  if (Array.isArray(answer)) return answer.length > 0 ? answer.join(', ') : 'skip';
  return String(answer);
}
